module.exports = __webpack_public_path__ + "static/A5xF4.c0440591.png";


//////////////////
// WEBPACK FOOTER
// ./images/A5xF4.png
// module id = 881
// module chunks = 168707334958949